import fr from "./fr";
import en from "./en";

const defaultLocale = "fr";
export { fr, en, defaultLocale };

export default { fr, en };
